import MicroModal from 'micromodal';

export const Modals = (function () {
	"use strict";

	const modalOptions = {
		onShow: (modal, element, event) => openTheModal(modal, element, event), // [1]
		onClose: (modal, element, event) => closeTheModal(modal, element, event), // [2]
		openTrigger: 'data-mircomodal-open', // [3]
		closeTrigger: 'data-mircomodal-close', // [4]
		openClass: 'is-open', // [5]
		disableScroll: true, // [6]
		disableFocus: true, // [7]
		awaitOpenAnimation: true, // [8]
		awaitCloseAnimation: true, // [9]
		debugMode: false // [10]
	};

	const openTheModal = (modal, element, event) => {
		document.body.classList.add('signup-modal-open');
		history.replaceState(null, null, `#${modal.id}`);
	};

	const closeTheModal = (modal, element, event) => {
		if (event) {
			event.preventDefault();
			event.stopPropagation();
		}

		document.body.classList.remove('signup-modal-open');

		modal.classList.remove('is-open');
		history.replaceState(null, null, ` `);
	};

	const checkModalOnloadStatus = () => {
		// if there is a hash that is longer than 0 characters AND if there is a modal on the page with that id
		if (
			window.location.hash.length > 2 &&
			$("#" + window.location.hash.substring(1) + ".modal").length > 0
		) {

			const modalId = window.location.hash.substring(1);

			// Don't allow the signup modal to open on mobile
			if (
				modalId === 'signup' &&
				window.innerWidth <= 768
			) {
				history.replaceState(null, null, window.location.pathname);
				return;
			}

			MicroModal.show(modalId, modalOptions);
		}
	};

	/**
	 * Fix overlay closing behavior.
	 *
	 * MicroModal's close attribute currently lives on .modal__overlay.
	 * Because .modal__container is inside the overlay, clicks inside the
	 * modal can otherwise be interpreted as overlay close clicks.
	 *
	 * We remove MicroModal's close attribute from the overlay and handle
	 * direct overlay clicks ourselves.
	 *
	 * The X button keeps data-mircomodal-close and continues to be
	 * handled normally by MicroModal.
	 */
	const setupModalOverlayClose = () => {
		const modalOverlays = document.querySelectorAll('.modal__overlay');

		if (modalOverlays && modalOverlays.length > 0) {
			modalOverlays.forEach((overlay) => {

				// Remove MicroModal close behavior from the wrapper/overlay.
				overlay.removeAttribute('data-mircomodal-close');

				// Avoid attaching our listener more than once.
				if (overlay.dataset.overlayCloseInitialized === 'true') {
					return;
				}

				overlay.dataset.overlayCloseInitialized = 'true';

				overlay.addEventListener('click', (event) => {

					// Only close when the overlay itself is clicked.
					// Clicks inside .modal__container will not close it.
					if (event.target === overlay) {
						MicroModal.close();
					}
				});
			});
		}
	};

	// Make sure that ajax-triggering links are watched. If one is clicked, re-create the list of ajax-triggering links (self-referential)
	// and re-set up the MicroModal to watch the new selection of modal triggers on the page
	// @author Aaron Hodge Silver
	const tagAjaxLinks = () => {
		var ajaxLinks = document.querySelectorAll(".ajax_trigger a");

		if (ajaxLinks && ajaxLinks.length > 0) {
			ajaxLinks.forEach((onelink) => {
				onelink.addEventListener(mytap, (e) => {
					setTimeout(function () {
						tagAjaxLinks();

						// Make sure newly injected modal overlays are
						// configured before MicroModal is initialized.
						setupModalOverlayClose();

						MicroModal.init(modalOptions);
					}, 1500);
				});
			});
		}
	};

	const mytap = window.ontouchstart === null ? "touchstart" : "click";

	function init() {

		// Configure overlay behavior before initializing MicroModal.
		setupModalOverlayClose();

		MicroModal.init(modalOptions);
		checkModalOnloadStatus();

		// setModalNavigation(); // Aaron commented this out on Sept 6 2023. Also the setModalNavigation() and setModalNavigation() functions. Angel wrote those, and they don't work and they often break other JS on the site.

		if (
			window.autoOpenSignupModal === true &&
			!window.location.hash &&
			window.innerWidth > 768
		) {
			setTimeout(() => {
				MicroModal.show('signup', modalOptions);
			}, window.autoOpenSignupDelay || 0);
		}

		// If anyone clicks an ajax link that might change page content, add listeners to all new items
		tagAjaxLinks();
	}

	return {
		init: init,
	};
})();